import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 10 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.900391 3.8999L3.56706 6.8999L8.90039 0.899902",
		stroke: "currentColor",
		strokeWidth: .83,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheck;
